import React from 'react';
import ModuleTable from 'Components/Core/ModuleTable';
import FormElement from 'Components/Core/Form/FormElement';
import MarketdataGroupSelector from './MarketdataGroupSelector';
import { setMarketdataForcedGroup, useMarketdataForcedGroup } from './marketdataForcedGroup';
import './Marketdata.css';

export default function MarketdataWatchlist(props) {

	const x = props.x;
	const wafId = props.id;
	const dialogFormId = "form-" + props.id;
	const [reloadKey, setReloadKey] = React.useState(0);
	const [selectedGroupId, setSelectedGroupId] = React.useState(null);
	// Checkbox "Trennlinie hinzufuegen" im Add/Edit-Dialog - deaktiviert die
	// uebrigen Felder (Symbol, Kurzbez., Boerse, Bezeichnung) und macht Symbol
	// nicht mehr mandatory, siehe MarketdataWatchlistSave.inc (eigener
	// "isseparator"-Pfad ohne FMP-Validierung).
	const [isSeparator, setIsSeparator] = React.useState(false);
	// Erzwungener Watchlist-Wechsel von aussen (siehe marketdataForcedGroup.js) -
	// "Watchlist bearbeiten" (Stift) in MarketdataQuotes.js/MarketdataCharts.js
	// setzt das, BEVOR dieses Modul aktiviert wird, damit die Verwaltung
	// dieselbe Watchlist zeigt, die in Live/Charts gerade ausgewaehlt war.
	const [forcedGroup, setForcedGroup] = React.useState(null);
	const consumeForcedGroup = useMarketdataForcedGroup(x, setForcedGroup);

	// Der Speichern-Button bleibt sonst nach dem Anklicken der Checkbox
	// deaktiviert: x.waf.checkChanged() (WebappForm.js) prueft zuerst
	// mandatoryOk() - im selben Klick-Event ist "symbol" dort aber noch als
	// mandatory=true UND leer registriert, weil FormElement das mandatory-Flag
	// erst in einem EIGENEN useEffect aktualisiert (Prop mandatory={!isSeparator}
	// aendert sich ja erst durch DIESEN Re-Render). Nach dem Commit (wenn
	// Kind-Effekte inkl. FormElement bereits gelaufen sind) den Button-Status
	// hier nochmal neu berechnen.
	React.useEffect(() => {
		if (x.waf[wafId]) {
			x.waf[wafId].onFormChanged();
		}
	}, [isSeparator, x, wafId]);

	// Table.js ruft onAddColumn(key, value) je Zeile spaltenweise auf, ohne
	// die gesamte Zeile mitzugeben - "isseparator" steht in der SELECT-Spalten-
	// reihenfolge (siehe MarketdataWatchlistList.inc) bewusst VOR den uebrigen
	// Feldern, damit dieser Merker beim Verarbeiten von symbol/shortlabel/... der
	// GLEICHEN Zeile schon gesetzt ist.
	let rowIsSeparator = false;

	// Mehrere Watchlists (Gruppen) statt einer einzigen globalen Liste - bewusst
	// ohne eigenen Menüpunkt (User-Vorgabe), stattdessen eine Auswahlbox direkt
	// hier und im Pendant MarketdataQuotes.js (siehe MarketdataGroupSelector.js).
	function changeGroup(groupId) {
		setSelectedGroupId(groupId);
		setReloadKey((current) => current + 1);
	}

	// Nach Drag-and-Drop-Umsortierung (siehe draggableRows/onReorder in
	// Table.js) die neue Reihenfolge als sortorder=Index speichern und die
	// Tabelle danach neu laden, damit die angezeigte "Sortierung"-Spalte
	// wieder zu den tatsaechlichen Werten passt (Table.js selbst zeigt die
	// neue Reihenfolge zwar sofort an, aber mit den alten sortorder-Zahlen).
	function handleReorder(newData) {
		const order = newData.map((row) => row.watchlistid);
		x.was.axPost('Backend/webapp.php?module=Marketdata&task=MarketdataWatchlistReorder', { order }, (result) => {
			if (result.data.returncode === 1) {
				setReloadKey((current) => current + 1);
			}
		});
	}

	const formFields =
		<React.Fragment>
			<HiddenGroupField x={x} wafId={wafId} groupId={selectedGroupId} />
			<div style={isSeparator ? { display: 'none' } : undefined}>
				<SymbolSearch x={x} wafId={wafId} />
			</div>
			<FormElement
				type="checkbox"
				x={x}
				wafId={wafId}
				id="isseparator"
				title="Trennlinie hinzufügen"
				onChange={(e) => setIsSeparator(e.target.checked)}
			/>
			{/* Bei aktivierter Checkbox bewusst per CSS (display:none) versteckt,
			    NICHT bedingt aus dem DOM entfernt - x.waf haelt pro Feld eine feste
			    React-Ref (siehe WebappForm.js/initField), die bei einem Unmount auf
			    null faellt; mandatoryOk()/checkChanged() lesen reference.current
			    aber ungeprueft und wuerden dann abstuerzen. display:none haelt die
			    Refs gueltig, versteckt aber Label+Eingabe vollstaendig (anders als
			    disabled, das nur ausgegraut wird und die Titel weiter anzeigt). */}
			<div style={isSeparator ? { display: 'none' } : undefined}>
				<FormElement type="text" x={x} wafId={wafId} id="symbol" mandatory={!isSeparator} title="Symbol (z.B. AAPL)" fieldValue="" maxLength="20" />
				<FormElement type="text" x={x} wafId={wafId} id="shortlabel" mandatory={false} title="Kurzbezeichnung (z.B. Gold)" fieldValue="" maxLength="20" />
				<FormElement type="text" x={x} wafId={wafId} id="exchange" mandatory={false} title="Börse" fieldValue="US" maxLength="20" />
				<FormElement type="text" x={x} wafId={wafId} id="label" mandatory={false} title="Bezeichnung" fieldValue="" maxLength="100" />
				<IgEpicField x={x} wafId={wafId} />
			</div>
		</React.Fragment>

	const watchlistSelector =
		<React.Fragment>
			<MarketdataGroupSelector x={x} id={props.id} onSelect={changeGroup} forcedGroup={forcedGroup} />
			{/* Umgekehrter Weg zu "Watchlist bearbeiten" (Stift) in Live/Charts -
			    springt zur jeweils gerade ausgewaehlten Watchlist statt der
			    Default-Watchlist, siehe marketdataForcedGroup.js. Der Toolbar-
			    Container (.module-table-title-toolbar) nutzt flex-direction:
			    row-reverse mit nur 4px gap - ohne zusaetzlichen Abstand kleben
			    diese Icons optisch direkt an der Watchlist-Auswahlbox. */}
			<i
				className="bi bi-broadcast module-icon"
				style={{ marginRight: '10px' }}
				title="Watchlist Live anzeigen"
				onClick={() => {
					setMarketdataForcedGroup(x, selectedGroupId);
					x.wam.activate('marketdata-quotes');
				}}
			/>
			<i
				className="bi bi-graph-up module-icon"
				title="Charts anzeigen"
				onClick={() => {
					setMarketdataForcedGroup(x, selectedGroupId);
					x.wam.activate('marketdata-charts');
				}}
			/>
		</React.Fragment>

	return (
		<ModuleTable
			id={props.id}
			tableId="watchlistid"
			dialogFormId={dialogFormId}
			x={x}
			classes="module-marketdata-watchlist"
			tableClasses="marketdata-watchlist-table"
			title={props.title}
			extraToolbar={watchlistSelector}
			onShow={consumeForcedGroup}
			addDeleteRow={true}
			addTitle="Symbol zur Watchlist hinzufügen"
			formTitle="Watchlist-Symbol"
			focusField="symbolsearch"
			module="Marketdata"
			listTask="MarketdataWatchlistList"
			listParams={'&groupid=' + selectedGroupId}
			deleteTask="MarketdataWatchlistDelete"
			reloadKey={reloadKey}
			draggableRows={true}
			onReorder={handleReorder}
			onAfterSend={() => {
				// Nach dem Speichern (v.a. einer Trennlinie) die Checkbox wieder
				// zuruecksetzen, sonst bleibt sie beim naechsten "+" angehakt und
				// die uebrigen Felder blieben faelschlich versteckt.
				x.waf.set(wafId, 'isseparator', 0);
				setIsSeparator(false);
			}}
			onAddHeader={(addHeader) => {
				addHeader('Symbol');
				addHeader('Kurzbez.');
				addHeader('Börse');
				addHeader('Bezeichnung');
				addHeader('Sortierung');
				addHeader('ISIN');
				addHeader('IG-Äquivalent');
			}}
			onRowClasses={(item) => (Number(item.isseparator) ? 'marketdata-watchlist-separator-row' : '')}
			onAddColumn={(key, value) => {
				switch (key) {
					case 'watchlistid':
						return false;
					case 'isseparator':
						// "isseparator" steht bewusst als erste echte Spalte in der
						// SELECT-Reihenfolge (siehe MarketdataWatchlistList.inc), damit
						// dieser Merker fuer die uebrigen Spalten DERSELBEN Zeile schon
						// gesetzt ist, bevor sie verarbeitet werden.
						rowIsSeparator = !!Number(value);
						return false;
					case 'symbol':
						return rowIsSeparator ? '—' : value;
					case 'shortlabel':
						return rowIsSeparator ? '' : value;
					case 'exchange':
						return rowIsSeparator ? '' : value;
					case 'label':
						return rowIsSeparator ? '' : value;
					case 'sortorder':
						return value;
					case 'isin':
						return rowIsSeparator ? '' : (value || '–');
					// comdirectinstrumentid steuert hier nichts mehr - der "Kaufen"-
					// Button ist in die Live-Ansicht umgezogen (Chat vom 2026-07-26,
					// siehe MarketdataQuotes.js), die Watchlist-Verwaltung ist reine
					// Stammdatenpflege.
					case 'comdirectinstrumentid':
						return false;
					// "dataprovider" steuert nur, ob "igepic" ausgewertet wird (leitet
					// sich beim Speichern automatisch aus igepic ab, siehe
					// MarketdataWatchlistSave.inc) - keine eigene Spalte noetig.
					case 'dataprovider':
						return false;
					case 'igepic':
						return rowIsSeparator ? '' : (value || '–');
					default:
						return false;
				}
			}}
			onEditRow={(e, rowFields, rowId) => {
				const separator = !!Number(rowFields.isseparator);
				x.waf.setAddSend(wafId, 'id', rowFields.watchlistid);
				x.waf.set(wafId, 'symbol', rowFields.symbol);
				x.waf.set(wafId, 'shortlabel', rowFields.shortlabel);
				x.waf.set(wafId, 'exchange', rowFields.exchange);
				x.waf.set(wafId, 'label', rowFields.label);
				x.waf.set(wafId, 'igepic', rowFields.igepic || '');
				x.waf.set(wafId, 'isseparator', separator ? 1 : 0);
				setIsSeparator(separator);
				x.waf.hide(wafId, 'message');
				x.wad[dialogFormId].setTitle("Watchlist-Symbol bearbeiten");
				x.wad[dialogFormId].show(() => { x.waf.focus(wafId, 'symbol') });
			}}
			formFields={formFields}
			formSendTask="MarketdataWatchlistSave"
		/>
	)

};

// Symbol-/Namenssuche (debounced, deckt Aktien, Krypto, Indizes und Futures ab
// - nicht nur Firmen) oberhalb des eigentlichen Symbol-Felds - eine Auswahl
// befuellt Symbol/Boerse/Bezeichnung automatisch ueber x.waf.set(), das
// darunterliegende Symbol-Feld bleibt trotzdem manuell editierbar (z.B. falls
// der Ticker schon bekannt ist und keine Suche noetig ist).
function SymbolSearch({ x, wafId, disabled }) {
	const [query, setQuery] = React.useState('');
	const [results, setResults] = React.useState([]);
	const debounceRef = React.useRef(null);
	const searchSequence = React.useRef(0);
	const inputRef = React.useRef(null);

	// Als eigenes Feld bei x.waf registrieren (wie FormElement.js es tut),
	// damit ModuleTable's focusField="symbolsearch" (siehe addRow() in
	// ModuleTable.js) x.waf.focus(wafId, 'symbolsearch') darauf anwenden kann -
	// ohne diese Registrierung kennt x.waf dieses Feld nicht und focus()
	// wuerde stillschweigend nichts tun.
	React.useEffect(() => {
		x.waf.initField(wafId, 'symbolsearch', inputRef, '', 'symbolsearch');
	}, [x, wafId]);

	function handleChange(e) {
		const value = e.target.value;
		setQuery(value);
		if (debounceRef.current) {
			clearTimeout(debounceRef.current);
		}
		if (value.trim().length < 2) {
			searchSequence.current += 1;
			setResults([]);
			return;
		}
		// Sequenznummer je Anfrage - der Debounce verhindert nur UEBERLAPPENDE
		// Timer, nicht ueberlappende Requests: tippt man waehrend eine Anfrage
		// noch unterwegs ist weiter, koennen zwei Requests gleichzeitig laufen.
		// Kommt die AELTERE Antwort (kuerzere/andere Suche) dann NACH der
		// neueren zurueck, ueberschreibt sie sonst faelschlich das aktuelle
		// Ergebnis - genau das sichtbare "kurz richtige Liste, dann von falscher
		// ueberschrieben"-Flackern. Nur die zuletzt gestartete Anfrage darf das
		// Ergebnis noch uebernehmen.
		searchSequence.current += 1;
		const currentSequence = searchSequence.current;
		debounceRef.current = setTimeout(() => {
			x.was.axPost('Backend/webapp.php?module=Marketdata&task=MarketdataSymbolSearch', { query: value }, (result) => {
				if (currentSequence !== searchSequence.current) {
					return;
				}
				if (result.data.returncode === 1) {
					setResults(result.data.content || []);
				}
			});
		}, 300);
	}

	function selectResult(row) {
		x.waf.set(wafId, 'symbol', row.symbol);
		x.waf.set(wafId, 'exchange', row.exchange);
		x.waf.set(wafId, 'label', row.name);
		// Kurzbezeichnung mit dem ersten Wort der Bezeichnung vorbelegen -
		// erspart erneutes Tippen, bleibt aber editierbar. Programmatisches
		// x.waf.set() umgeht das maxLength="20" des Feldes (das nur
		// Tastatureingaben begrenzt) - der volle FMP-Firmenname (z.B.
		// "Barrick Gold Corporation") ueberschreitet sonst die
		// shortlabel-Spalte (VARCHAR(20)) und das Speichern schlaegt fehl.
		x.waf.set(wafId, 'shortlabel', row.name.split(' ')[0].slice(0, 20));
		setQuery('');
		setResults([]);
	}

	return (
		<div className="marketdata-symbol-search">
			<label className="marketdata-symbol-search-label">Symbol oder Name suchen</label>
			<input
				ref={inputRef}
				type="text"
				className="form-control rounded-pill"
				value={query}
				onChange={handleChange}
				placeholder="z.B. Apple, AAPL, Bitcoin, Gold"
				autoComplete="off"
				disabled={disabled}
			/>
			{results.length > 0 &&
				<ul className="marketdata-symbol-search-results">
					{results.map((row) => (
						<li key={row.symbol} onClick={() => selectResult(row)}>
							<strong>{row.symbol}</strong> <span>{row.name}</span>
						</li>
					))}
				</ul>
			}
		</div>
	);
}


// IG-Aequivalent-Zuordnung (optional, siehe marketdataWatchlist-Spalten
// igepic/dataprovider) - ist ein Epic gesetzt, hat es IMMER Vorrang vor
// EODHD fuer die Kursermittlung (User-Vorgabe, siehe MarketdataChart.inc/
// MarketdataQuotes.inc, die zuerst "dataprovider"/"igepic" nachschlagen).
// IG hat anders als EODHD keine ISIN-Zuordnung, nur eine unscharfe Namens-/
// Symbolsuche (IgClient::searchMarkets()) - gleiches Debounce-/Sequenz-
// Muster wie SymbolSearch oben, das darunterliegende Textfeld bleibt
// trotzdem manuell editierbar (Epic direkt einzutippen, falls schon bekannt).
function IgEpicField({ x, wafId }) {
	const [query, setQuery] = React.useState('');
	const [results, setResults] = React.useState([]);
	const debounceRef = React.useRef(null);
	const searchSequence = React.useRef(0);

	function handleChange(e) {
		const value = e.target.value;
		setQuery(value);
		if (debounceRef.current) {
			clearTimeout(debounceRef.current);
		}
		if (value.trim().length < 2) {
			searchSequence.current += 1;
			setResults([]);
			return;
		}
		searchSequence.current += 1;
		const currentSequence = searchSequence.current;
		debounceRef.current = setTimeout(() => {
			x.was.axPost('Backend/webapp.php?module=Marketdata&task=MarketdataIgSearch', { query: value }, (result) => {
				if (currentSequence !== searchSequence.current) {
					return;
				}
				if (result.data.returncode === 1) {
					setResults(result.data.content || []);
				}
			});
		}, 300);
	}

	function selectResult(row) {
		x.waf.set(wafId, 'igepic', row.epic);
		setQuery('');
		setResults([]);
	}

	return (
		<div className="marketdata-ig-epic-field">
			<div className="marketdata-symbol-search">
				<label className="marketdata-symbol-search-label">IG-Äquivalent suchen (optional, hat Vorrang bei der Kursermittlung)</label>
				<input
					type="text"
					className="form-control rounded-pill"
					value={query}
					onChange={handleChange}
					placeholder="z.B. Gold, Brent, US Tech 100"
					autoComplete="off"
				/>
				{results.length > 0 &&
					<ul className="marketdata-symbol-search-results">
						{results.map((row) => (
							<li key={row.epic} onClick={() => selectResult(row)}>
								<strong>{row.epic}</strong> <span>{row.name}{row.type ? ' (' + row.type + ')' : ''}{row.expiry ? ' – ' + row.expiry : ''}</span>
							</li>
						))}
					</ul>
				}
			</div>
			<FormElement type="text" x={x} wafId={wafId} id="igepic" mandatory={false} title="IG-Epic" fieldValue="" maxLength="60" />
		</div>
	);
}

// Unsichtbares Feld, das die aktuell ausgewaehlte Watchlist (groupid) beim
// Anlegen/Bearbeiten eines Symbols mitschickt - der Nutzer waehlt die
// Watchlist ueber die Auswahlbox im Toolbar, nicht im Dialog selbst.
function HiddenGroupField({ x, wafId, groupId }) {
	const inputRef = React.useRef(null);

	React.useEffect(() => {
		x.waf.initField(wafId, 'groupid', inputRef, '', 'groupid');
	}, [x, wafId]);

	React.useEffect(() => {
		if (groupId !== null && x.waf.isField(wafId, 'groupid')) {
			x.waf.set(wafId, 'groupid', groupId, true);
		}
	}, [x, wafId, groupId]);

	return <input type="hidden" ref={inputRef} />;
}
